// Attribute specific permission props
import {i18n} from '@netx/core/i18n';

// TODO: Explain why - I cannot remember why - is it that only admins can administer the attibute templates themeselves?
export const attribute = {
	modes: ['read', 'write'],
};

export const modes = {
	read: i18n.t('i18n.read'),
	write: i18n.t('i18n.write'),
	delete: i18n.t('i18n.delete'),
};

export const specialModes = {
	read: i18n.t('i18n.viewer'),
	write: i18n.t('i18n.contributor'),
	delete: i18n.t('i18n.manager'),
};

export const resourceLabels = {
	attribute: i18n.t('i18n.attribute'),
	attributeSet: i18n.t('i18n.attributeSet'),
	savedCart: i18n.t('i18n.savedCart'),
	savedSearch: i18n.t('i18n.savedSearch'),
};

export const targets = {
	all: i18n.t('i18n.all'),
	group: i18n.t('i18n.group'),
	user: i18n.t('i18n.user'),
};

export default {
	attribute: attribute,
	modes: modes,
	resourceLabels: resourceLabels,
	specialModes: specialModes,
	targets: targets,
};
